import { jsx as _jsx } from "react/jsx-runtime";
import s from '../Popup.module.scss';
export const PopperContainer = ({ children, popper }) => {
    const bottomTransform = (popper === null || popper === void 0 ? void 0 : popper['data-popper-placement']) === 'bottom' && 'translate(-63px, 63px)';
    const popperStyle = Object.assign(Object.assign({}, popper.style), { transform: bottomTransform || popper.style.transform });
    return (_jsx("div", Object.assign({ className: s.popup_proposal_card }, popper, { style: popperStyle }, { children: children })));
};
